import React from 'react';
import styles from './visits.module.scss';

interface VisitsProps {
  multiplier?: number;
}

export default function Visits({ multiplier = 1 }: VisitsProps) {

	function getComplitedAmount():number {
		const curDate:Date = new Date();
		const curHours:number = curDate.getHours();
		const curMinutes:number = curDate.getMinutes();
		return Math.floor((curHours*60 + curMinutes)/45) * multiplier;
	}

	return (
		<div className={styles.visits}>
			Сегодня тестов пройдено: <b>{getComplitedAmount()}</b>
		</div>
	);
}